import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {Row, Form, Button, Icon, Input, Divider} from 'antd';

import {RTLCol,RTLButton} from '../RTLKit';


/* ------ Field -------- */
import TextField from '../formFields/TextField';
import SelectField from '../formFields/SelectField';
import TextAreaField from '../formFields/TextAreaField';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";

class AddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            cities:[],
            formLayout: 'horizontal',
            role:this.props.userValue ? this.props.userValue.rl : null
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        if (this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.getItem(id)
        }


    }

    __fixCitiesObject(list) {
        let dataSource = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].title, value: list[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;

        /*---- set mode ---*/
        if(this.props.initialValues) {
            this.props.initialValues.mode=this.state.mode
        }

        /* ----- find selected city  -----*/
        if(this.props.initialValues && this.state.mode == 'edit') {
            this.state.stateId = this.props.initialValues.state
        }


        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">{this.state.mode == 'edit' ? "ویرایش" : "ایجاد"} دسته بندی</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>

                            <Field
                                name="title"
                                component={TextField}
                                type="text"
                                label="عنوان"
                                placeholder="عنوان"
                            />
                            <Field
                                name="description"
                                component={TextField}
                                type="text"
                                label="توضیحات"
                                placeholder="توضیحات"
                            />
                            <Field
                                name="product_type"
                                component={SelectField}
                                label="نوع دسته بندی محصول"
                                placeholder="نوع دسته بندی محصول"
                                disabled = {(this.state.mode == 'edit' )? 'disabled' : null}
                                list={[
                                    {label: 'مشتری', value: 'PRODUCT_CATEGORY_CUSTOMER_TYPE', key: 1},
                                    {label: 'تکنسین', value: 'PRODUCT_CATEGORY_TECHNICIAN_TYPE', key: 2}
                                    ]}
                            />
                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/product-category/list" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default AddEditForm = reduxForm({
    form: 'addCategory',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(AddEditForm)
